import { useState, useRef, type InputHTMLAttributes } from 'react';

export interface SearchBarProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  /** 検索値 */
  value?: string;
  /** 値変更時のコールバック */
  onChange?: (value: string) => void;
  /** プレースホルダー */
  placeholder?: string;
  /** アイコン名（Material Symbols） */
  icon?: string;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * 検索バーコンポーネント
 */
export const SearchBar: React.FC<SearchBarProps> = ({
  value = '',
  onChange,
  placeholder = '検索',
  icon = 'search',
  className = '',
  ...rest
}) => {
  const [internalValue, setInternalValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  const currentValue = value !== undefined ? value : internalValue;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    onChange?.(newValue);
  };

  const handleClear = () => {
    setInternalValue('');
    onChange?.('');
    inputRef.current?.focus();
  };

  return (
    <div className={`aip-search-bar ${className}`.trim()}>
      <span className="material-symbols-outlined aip-search-bar__icon">{icon}</span>
      <input
        ref={inputRef}
        className="aip-search-bar__input"
        type="text"
        placeholder={placeholder}
        value={currentValue}
        onChange={handleChange}
        {...rest}
      />
      <button
        type="button"
        className="aip-search-bar__clear"
        tabIndex={-1}
        onClick={handleClear}
        aria-label="クリア"
      >
        <span className="material-symbols-outlined aip-search-bar__clear-icon">cancel</span>
      </button>
    </div>
  );
};

export default SearchBar;




